import { AudienceFilter, defineTopic } from 'magpie-lib/models';
import { navVisibilityControls, navConfigControls, bookmarksApi, csatControls } from '../messages';
export const NAVIGATION_PUBLIC_API_TOPIC_NAME = '@@navigation/public-api';
export const navPublicApiAudience = AudienceFilter.builder().excludeSelf();
export const navigationPublicApiTopicDef = defineTopic({
  name: NAVIGATION_PUBLIC_API_TOPIC_NAME,
  messages: [navVisibilityControls.changeNavVisibility, navVisibilityControls.getNavVisibility, navVisibilityControls.navVisibilityChanged, navConfigControls.requestInvalidation, bookmarksApi.addBookmark, bookmarksApi.bookmarkChanged, bookmarksApi.removeBookmark, csatControls.scheduleCsatSurvey, csatControls.cancelScheduledCsatSurvey, csatControls.csatSurveyOpened],
  enableRuntimeValidation: false,
  audience: navPublicApiAudience.build()
});